import { CheckListSimpleResponse } from "../../../types/types";
import { api } from "../api";

/**
 * Busca a lista simplificada de checklists para uso em campos de selecao.
 * GET /checklists/list/{customerId}/{vehicleId}
 */
const checklistFindAllSimpleResponse = async (
    token: string,
    customerId: number,
    vehicleId: number,
) => {
    const response = await api.get<CheckListSimpleResponse[]>(
        `/checklists/list/${customerId}/${vehicleId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    return response;
};

export default checklistFindAllSimpleResponse;
